export const floatingCardLayout = {
    About: {
        width: 340,
        height: 308,
        top: '20px',
        left: '50%',
        offsetX: 128,
        offsetY: 380,
        // transform: 'translateX(-50%)'
    },
    Reading: {
        width: 299,
        height: 200,
        top: '25px',
        left: '52%',
        offsetX: -180,
        offsetY: 370,
        // transform: 'translateX(-50%)'
    },
    Education: {
        width: 280,
        height: 280,
        top: '15px',
        left: '48%',
        offsetX: 140,
        offsetY: 380,
        // transform: 'translateX(-50%)'
    },
    Media: {
        width: 300,
        height: 270,
        top: '30px',
        left: '50%',
        offsetX: -140,
        offsetY: 360,
        // transform: 'translateX(-50%)'
    },
    Technologies: {
        width: 290,
        height: 380,
        top: '18px',
        left: '50%',
        offsetX: 160,
        offsetY: 380,
        // transform: 'translateX(-50%)'
    },
    Experience: {
        width: 350,
        height: 420,
        top: '22px',
        left: '49%',
        offsetX: 180,
        offsetY: 400,
        // transform: 'translateX(-50%)'
    },
    Contact: {
        width: 300,
        height: 200,
        top: '28px',
        left: '51%',
        offsetX: 100,
        offsetY: 390,
        // transform: 'translateX(-50%)'
    }
};
